function configure(Highcharts) {
    Highcharts.wrap(Highcharts.Axis.prototype, "init", function (proceed, chart, userOptions) {
        proceed.call(this, chart, userOptions);
        this.imitateBrokenAxis = userOptions.imitateBrokenAxis;
        if (!this.horiz && this.imitateBrokenAxis) {
            //@ts-ignore Accessing Highcharts internals.
            var oldLabelFormatter = this.labelFormatter;
            //@ts-ignore Setting Highcharts internals.
            this.labelFormatter = function () {
                if (this.isFirst) {
                    var formatted = oldLabelFormatter.call(this);
                    var m = new RegExp("\\" + Highcharts.getOptions().lang.decimalPoint + "\\d*$").exec(formatted);
                    if (m) {
                        return "0.000000".substr(0, m[0].length + 1);
                    }
                    return 0;
                }
                return oldLabelFormatter.call(this);
            };
        }
    });
    Highcharts.wrap(Highcharts.Axis.prototype, "getLinePath", function (proceed, lineWidth) {
        var axis = this, path = proceed.call(this, lineWidth), start = path[0], x = start[1];
        if (!axis.horiz && axis.imitateBrokenAxis) {
            var y = axis.toPixels(axis.min, false) - 16;
            path.splice(1, 0, ['L', x, y - 4], // stop
            ['M', x + 5, y - 9], ['L', x - 5, y + 1], // lower slanted line
            ['M', x + 5, y - 1], ['L', x - 5, y + 9], // higher slanted line
            ['M', x, y + 4]);
        }
        return path;
    });
}
export default configure;
